module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-metals-remnants.3595c291.png";